import React, { ReactElement, useEffect } from 'react';
import SearchSidebar from './search-sidebar';
import KretsSidebar from './krets-sidebar';
import TypeSidebar from './type-sidebar';
import DateSidebar from './date-sidebar';
import { SideBarProps } from '../types';
import { stickyKitRecalc } from '../utils';

export default function SideBar(props: SideBarProps): ReactElement {
  useEffect(() => {
    stickyKitRecalc();
  });
  return (
    <div>
      <SearchSidebar {...props} />
      <TypeSidebar {...props} />
      <KretsSidebar {...props} />
      <DateSidebar {...props} />
    </div>
  );
}
